// External libraries
import React from 'react';
import { useStoreState } from '@/store';

// Internal modules
import { features, getLocale } from '@/lib';
import { NationalitySelect } from './NationalitySelect';
import { useMountLogging } from '@/lib/reactHooks';
import { NationalityContainer } from './StyledComponents';
import { NationalitySelectBox } from './NationalitySelectBox';

export type NationalityProps = {
  blurHandler: (e: React.FocusEvent<HTMLInputElement>) => void;
  changeHandler: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

const Nationality = (props: NationalityProps): JSX.Element => {
  useMountLogging('Nationality');
  const hasAddress = features.isNotActive('isAddressless');
  const shouldCollapseNationalitySelectBox = features.isActive(
    'shouldCollapseNationalitySelectBox',
  );
  const showSelectNationalityBox =
    hasAddress && !shouldCollapseNationalitySelectBox;

  const isFormSubmitting = useStoreState(({ ui }) => ui.isFormSubmitting);
  const selectOptions = useStoreState(({ api }) => {
    const { locale } = getLocale();
    return api.griffinMetadata?.territories[locale];
  });

  if (showSelectNationalityBox) {
    return (
      <NationalityContainer isFirstField={!hasAddress}>
        <NationalitySelectBox
          // @ts-expect-error disabled doesn't exist
          disabled={isFormSubmitting}
          selectOptions={selectOptions}
          shouldFocusOnRender={!hasAddress}
          {...props}
        />
      </NationalityContainer>
    );
  }

  return (
    <NationalityContainer isFirstField={!hasAddress}>
      <NationalitySelect />
    </NationalityContainer>
  );
};

export { Nationality };
